<accredible-banner-panel *transloco="let t; read: 'panel'"
  [backgroundImage]="bannerImagePath"
  [backgroundGradient]="bannerBackgroundGradient"
  [bannerHeight]="'100vh'">
  <ng-container mainContent>
    <div class="main-panel">
      <!-- Hidden div for justify-content: space-between; -->
      <div></div>

      <div class="main-panel-content">
        <img src="/assets/images/accredible.png"
          [alt]="t('accredible_logo')">

        @if (showBackToSignIn) {
          <div class="back">
            <a class="link-with-icon"
              routerLink="/"
              queryParamsHandling="preserve">
              <mat-icon class="mat-icon-rtl-mirror">navigate_before</mat-icon>
              <span>{{ t('back_to_sign_in') }}</span>
            </a>
          </div>
        }

        <ng-content></ng-content>
      </div>

      <acs-mini-footer/>
    </div>
  </ng-container>
</accredible-banner-panel>
